import { useCallback } from 'react'
import { createAttachmentFromDocumentItem } from './createAttachmentFromDocumentItem'
import { MAX_MESSAGE_ATTACHMENTS } from './aiAskBarLayoutConstants'
import { pushRecentDocuments } from './recentDocumentsStore'

/**
 * Attaching documents that already exist.
 *
 * These never touch the upload endpoint — the file is already stored — so they
 * need no chat, no key and no registry entry.
 */
export function useAiAskBarLibraryAttach({ attachmentsRef, setAttachments }) {
  const handleSelectLibraryDocuments = useCallback(
    (items) => {
      const remaining = MAX_MESSAGE_ATTACHMENTS - attachmentsRef.current.length
      if (remaining <= 0 || !items?.length) return
      const toAdd = items.slice(0, remaining).map((item) => createAttachmentFromDocumentItem(item))
      pushRecentDocuments(items)
      setAttachments((prev) => [...prev, ...toAdd])
    },
    [attachmentsRef, setAttachments],
  )

  const handleAttachRecentDocument = useCallback(
    (item) => {
      if (attachmentsRef.current.length >= MAX_MESSAGE_ATTACHMENTS) return
      if (attachmentsRef.current.some((entry) => entry.documentId === item.id)) return
      pushRecentDocuments([item])
      setAttachments((prev) => [...prev, createAttachmentFromDocumentItem(item)])
    },
    [attachmentsRef, setAttachments],
  )

  return { handleSelectLibraryDocuments, handleAttachRecentDocument }
}
